import { create } from "zustand";
import type { UserSelfDTO } from "../types/user/UserSelfDTO";

type UserSelfState = {
  userSelf: UserSelfDTO | null;
  setUserSelf: (user: UserSelfDTO | null) => void;
  reset: () => void;
};

export const useUserSelfStore = create<UserSelfState>((set) => ({
  userSelf: null,
  setUserSelf: (userSelf) => set({ userSelf }),
  reset: () => set({ userSelf: null }),
}));
